import catalogsService from "@/services/catalogsService"
import {errorHttpMessage} from "@/utils/errorDecodeUtil"

// Carga las empresas (tenants) del producto resiliencia para el selector
export const loadTenants = async ({commit}) => {
  try {
    const {data: result} = await catalogsService.getTenantsList({product: 'resiliencia'})
    const {data, message, error} = result.result
    commit('setTenantsList', error ? [] : data.map(el => ({...el, text: el.business_name})))
    return {data, message, error}
  } catch (ex) {
    commit('setTenantsList', [])
    const error_http_message = errorHttpMessage(ex)
    return {message: error_http_message.message, error_keys: error_http_message.error_keys, data: ex.response?.data, error: true}
  }
}
